/**
 * Global App Initialization
 * Sets up global utilities and singletons for the entire application
 * Import this file early in your app initialization
 */

import { getGlobalScrollLockManager } from "./scrollLock.js";

// Initialize global scroll lock manager
const init_globalUtils = () => {
  // Ensure scroll lock manager is available globally
  const scrollManager = getGlobalScrollLockManager();

  // Add global cleanup for page unload/SPA navigation
  window.addEventListener("beforeunload", () => {
    scrollManager.unlockAll();
  });

  // Optional: Add global keyboard shortcuts
  document.addEventListener("keydown", (e) => {
    // Emergency unlock with Ctrl+Shift+U (or Cmd+Shift+U on Mac)
    if ((e.ctrlKey || e.metaKey) && e.shiftKey && e.key === "U") {
      scrollManager.unlockAll();
      console.log("🚨 Emergency scroll unlock triggered");
    }
  });

  console.log("🚀 Global app utilities initialized");
  return {
    scrollManager,
  };
};

// Auto-initialize if this module is imported
const globalUtils = init_globalUtils();

export default globalUtils;
